import { render } from "./file-upload-popup.vue?vue&type=template&id=ca6d0234"
import script from "./file-upload-popup.vue?vue&type=script&lang=js"
export * from "./file-upload-popup.vue?vue&type=script&lang=js"

import "./file-upload-popup.vue?vue&type=style&index=0&id=ca6d0234&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__